import { customAlphabet } from "nanoid";

const ALPHABET = "0123456789abcdefghijklmnopqrstuvwxyz";

const SIZE = 20;

export const nanoid = customAlphabet(ALPHABET, SIZE);
